import { Input, Spinner } from '@billda/design-system';
import { SearchIcon } from '@billda/design-system';
import { ChangeEvent } from 'react';

interface GangMemberSearchInputProps {
  value: string;
  placeholder: string;
  isLoading: boolean;
  onChange: (value: string) => void;
}

export const GangMemberSearchInput = ({
  value,
  placeholder,
  isLoading,
  onChange,
}: GangMemberSearchInputProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className="mb-4" data-testid="user-search">
      <Input
        placeholder={placeholder}
        data-testid="gang-member-search-input"
        value={value}
        onChange={handleChange}
        startAdornment={
          <SearchIcon
            aria-hidden="true"
            className="size-4 text-content-secondary"
          />
        }
        endAdornment={
          isLoading ? (
            <Spinner size={20} data-testid="user-search-loading" />
          ) : null
        }
      />
    </div>
  );
};
